import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import {
  isCateringOrderCancelled,
  isCateringOrderCheckedIn,
  isCateringOrderCompleted,
} from 'common/utilities/orderStatusUtils';

/*********************************************************************
 *
 *
 *********************************************************************/
const getCateringOrderStoreNameOrderIdPanelJSX = params => {
  const { orderDetails } = params;
  const { storeName, displayOrderId } = orderDetails;
  return (
    <>
      <div className={`catering-store-order`}>{storeName}</div>
      {displayOrderId && (
        <div className='catering-store-order red'>
          {translateWithI18Next(TRANSLATE_MAPPING_KEY?.ORDER_HASH)?.toUpperCase() + displayOrderId}
        </div>
      )}
    </>
  );
};

/*********************************************************************
 *
 *
 *********************************************************************/
const getCateringOrderTimePanelJSX = params => {
  const { orderDetails } = params;
  const { orderStatus, deliveryOrEstimatedOrCollectAtTime } = orderDetails;
  return (
    <>
      <div className={`estimated-arrival estimated-arrival-refund ${orderStatus}-delivery`}>
        {translateWithI18Next(TRANSLATE_MAPPING_KEY?.COLLECTED_AT)}
      </div>
      <div className='idAndTime time-delivery'>{deliveryOrEstimatedOrCollectAtTime}</div>
    </>
  );
};

/*********************************************************************
 *
 *
 *********************************************************************/
const getCateringStatusIconJSX = params => {
  const { orderDetails } = params;
  const { orderStatus } = orderDetails;

  const imageSrcFn = () => {
    if (isCateringOrderCancelled(orderDetails)) {
      return IMAGE_PATH?.CartError;
    } else if (isCateringOrderCheckedIn(orderDetails)) {
      return IMAGE_PATH?.ConfirmedImg;
    }
    return IMAGE_PATH?.clockFeature;
  };
  const imageSrc = imageSrcFn();

  return imageSrc !== '' && <img src={imageSrc} className='statusIcon' alt={orderStatus} />;
};

/*********************************************************************
 *
 *
 *********************************************************************/
const getCateringOrderStatusMessageString = orderDetails => {
  if (isCateringOrderCancelled(orderDetails)) {
    return translateWithI18Next(TRANSLATE_MAPPING_KEY?.CANCEL_ORDER);
  } else if (isCateringOrderCheckedIn(orderDetails)) {
    return translateWithI18Next(TRANSLATE_MAPPING_KEY?.ENJOY_MEAL);
  }
  return `${translateWithI18Next(TRANSLATE_MAPPING_KEY?.THANK_YOU)}, ${orderDetails?.customer?.firstName.replace(
    /(.{7})..+/,
    '$1...',
  )}`;
};

/*********************************************************************
 *
 *
 *********************************************************************/
const getCateringStatusMessageJSX = params => {
  const { orderDetails } = params;
  const {
    orderStatus,
    service,
    selectedCateringOrderCollectionMethod,
    deliveryOrEstimatedOrCollectAtMonthDate,
    deliveryOrEstimatedOrCollectAtTime,
  } = orderDetails;

  const statusMessage = getCateringOrderStatusMessageString(orderDetails);

  return (
    statusMessage !== '' && (
      <div
        className={`allSet ${orderStatus}-allSet ${service} ${selectedCateringOrderCollectionMethod} col-12 ${
          isCateringOrderCompleted(orderDetails) ? '' : 'p-0px-imp'
        }`}
      >
        <div className='statusMessage'>{statusMessage}</div>

        {!isCateringOrderCompleted(orderDetails) && (
          <div className='catering-order-deliver-details'>
            {`${translateWithI18Next(TRANSLATE_MAPPING_KEY?.YOUR_CATERING)}`}{' '}
            <span className='red'>{deliveryOrEstimatedOrCollectAtMonthDate}</span>{' '}
            {translateWithI18Next(TRANSLATE_MAPPING_KEY?.AT)}{' '}
            <span className='red'>{deliveryOrEstimatedOrCollectAtTime}</span>
          </div>
        )}
        {!isCateringOrderCompleted(orderDetails) && (
          <div className='catering-confirmation-email-details'>{`${translateWithI18Next(
            TRANSLATE_MAPPING_KEY?.CATERING_CONFIRMATION_EMAIL,
          )}`}</div>
        )}
      </div>
    )
  );
};

/*********************************************************************
 *
 *
 *********************************************************************/
const getCateringPartnerOTPPanelJSX = params => {
  const { orderDetails } = params;
  const { deliveryPartner, deliveryDetails } = orderDetails;
  const otp = deliveryPartner?.otp || deliveryDetails?.otp;
  return (
    !isCateringOrderCompleted(orderDetails) &&
    otp && (
      <>
        <div className='estimated-arrival estimated-arrival-refund driver-msg col-12'>
          {translateWithI18Next(TRANSLATE_MAPPING_KEY?.ASK_FOR_OTP)}
        </div>
        <div className='idAndTime time-delivery'>
          <div className='red otp'>{otp}</div>
        </div>
      </>
    )
  );
};

/*********************************************************************
 *
 *
 *********************************************************************/
export const displayCateringStatusPanelJSX = params => {
  return (
    <>
      {!isCateringOrderCompleted(params?.orderDetails) && getCateringOrderStoreNameOrderIdPanelJSX(params)}
      {isCateringOrderCheckedIn(params?.orderDetails) && getCateringOrderTimePanelJSX(params)}
      {getCateringStatusIconJSX(params)}
      {getCateringStatusMessageJSX(params)}
      {getCateringPartnerOTPPanelJSX(params)}
    </>
  );
};
